"use strict";
module.exports = function(config, get, post){
	return {
		addOption: handle_add_option,
		updateOption: handle_update_option,
		removeOption: handle_remove_option,
		searchOption: handle_search_option,

		list: handle_list_schemas,
		listOrg: handle_list_org_schemas
	};

	function handle_add_option(schema, data){
		return post("/v2/org/options/add/option", {
			schema,
			data
		});
	}

	function handle_update_option(option, data){
		return post("/v2/org/options/update/option", {
			option,
			data
		});
	}

	function handle_remove_option(option){
		return post("/v2/org/options/remove/option", {
			option
		});
	}

	function handle_search_option(schema, fields, search, page){
		return get("/v2/org/options/search/option", {
			schema,
			fields,
			search,
			page
		});
	}

	function handle_list_schemas(page){
		return get("/v2/org/options/list/schemas", {
			page
		});
	}

	function handle_list_org_schemas(page){
		return get("/v2/org/options/org/list/schemas", {
			page
		});
	}
};